import React, { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { API_BASE_URL } from "../../config";

// Lands here from the link in the confirmation email. The token arrives in the
// query string and is exchanged immediately; it is single-use and expires in
// three days.

export default function VerifyEmail() {
    const [params] = useSearchParams();
    const token = params.get('token');
    const [state, setState] = useState(token ? 'working' : 'missing');
    const [message, setMessage] = useState('');
    // React 18 mounts effects twice in development. Without this the token is
    // exchanged, burned, and then exchanged again -- and the second attempt
    // reports failure on a verification that actually succeeded.
    const sent = useRef(false);

    useEffect(() => {
        if (!token || sent.current) return;
        sent.current = true;

        fetch(`${API_BASE_URL}/api/auth/verify-email`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ token }),
        })
            .then(async (res) => {
                const data = await res.json().catch(() => ({}));
                setMessage(data.message || '');
                setState(res.ok ? 'ok' : 'failed');
            })
            .catch(() => {
                setMessage('Network error. Try the link again.');
                setState('failed');
            });
    }, [token]);

    return (
        <div className="wb-page wb-page--narrow">
            <h1>
                {state === 'ok' ? 'Email confirmed' :
                 state === 'working' ? 'Confirming…' : 'That link did not work'}
            </h1>

            {state === 'missing' && (
                <p className="wb-sub">
                    This page needs a confirmation link. Check your email for the message we
                    sent when you signed up.
                </p>
            )}

            {message && (
                <div className={state === 'ok' ? 'wb-note wb-note--ok' : 'wb-note wb-note--danger'}>
                    {message}
                </div>
            )}

            {state === 'ok' && (
                <p style={{ marginTop: '1.5rem' }}>
                    <Link to="/login" className="wb-btn wb-btn--primary">Sign in</Link>
                </p>
            )}

            {state === 'failed' && (
                <p className="wb-sub" style={{ marginTop: '1rem' }}>
                    Links expire after three days. Sign in and ask for a new one from your
                    profile. <Link to="/login">Sign in</Link>
                </p>
            )}
        </div>
    );
}
